<template>
  <v-app>
    <!-- navbar (show-over-1537px) -->
    <div class="show-over-1537px" style="position: sticky; top: 0; z-index: 99; height: 80px; width: 100%; background-color: #ffffff; border-bottom: 1px solid #EFF0F6; box-shadow: 0px 2px 4px 0px #2424241A">
      <div class="d-flex align-center justify-center" style="height: 100%; width: 100%">
        <div class="d-flex align-center justify-center" style="width: 1536px; position: relative">
          <!-- logo(absolute) -->
          <img @click="goHome()" src="@/assets/cogcom_logo.png" style="position: absolute; left: 0; height: 29px; cursor: pointer">
          <!-- tabs - 솔루션, 활용 사례, 인사이트 -->
          <div class="d-flex align-center" style="gap: 10px; position: relative">
            <!-- 솔루션 -->
            <v-menu offset-y open-on-hover content-class="elevation-0" nudge-left="76">
              <template v-slot:activator="{ on }">
                <div v-on="on"
                  class="hover-bg-color d-flex align-center"
                  style="--hover-bg-color: #EFF0F6; height: 50px; padding: 0px 24px; border-radius: 999px; cursor: pointer"
                >
                  <div style="font-size: 17px; font-weight: 500; line-height: 24px; letter-spacing: -0.02em; color: #0D0E17">
                    솔루션
                  </div>
                </div>
              </template>
              <div style="width: 480px; padding-top: 15px">
                <div class="d-flex flex-column" style="width: 100%; background-color: #ffffff; border-radius: 0px 0px 16px 16px; padding: 16px 30px 28px; gap: 20px">
                  <!-- Re:Column -->
                  <div @click="openRecolumn()" class="navbar-menu-list-item d-flex align-center" style="width: 100%; height: 96px; gap: 20px; cursor: pointer">
                    <!-- img -->
                    <div style="width: 120px; height: 100%; border-radius: 9.6px; border: 1.2px solid #E8EAF2; overflow: hidden">
                      <img src="@/assets/navbar/navbar_hoverMenu_1_1.png" style="width: 100%">
                    </div>
                    <!-- title, sub -->
                    <div class="d-flex flex-column" style="gap: 4px">
                      <!-- title -->
                      <div style="font-size: 18px; font-weight: 500; line-height: 25px; letter-spacing: -0.02em; color: #0D0E17">
                        Re:Column
                      </div>
                      <!-- title -->
                      <div style="font-size: 15px; font-weight: 400; line-height: 21px; letter-spacing: -0.02em; color: #414458">
                        데이터 ∙ 문서 업무가 반복된다면, <br> 리컬럼 도입을 고려하실 때입니다.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </v-menu>
            <!-- 활용 사례 -->
            <v-menu offset-y open-on-hover content-class="elevation-0" nudge-left="177">
              <template v-slot:activator="{ on }">
                <div v-on="on"
                  class="hover-bg-color d-flex align-center"
                  style="--hover-bg-color: #EFF0F6; height: 50px; padding: 0px 24px; border-radius: 999px; cursor: pointer"
                >
                  <div style="font-size: 17px; font-weight: 500; line-height: 24px; letter-spacing: -0.02em; color: #0D0E17">
                    활용 사례
                  </div>
                </div>
              </template>
              <div style="width: 480px; padding-top: 15px">
                <div class="d-flex flex-column" style="width: 100%; background-color: #ffffff; border-radius: 0px 0px 16px 16px; padding: 16px 30px 28px; gap: 20px">
                  <!-- Case Study -->
                  <div @click="windowOpen('https://blog.naver.com/PostList.naver?blogId=cogcominc&from=postList&categoryNo=7')" class="navbar-menu-list-item d-flex align-center" style="width: 100%; height: 96px; gap: 20px; cursor: pointer">
                    <!-- img -->
                    <div style="width: 120px; height: 100%; border-radius: 9.6px; border: 1.2px solid #E8EAF2; overflow: hidden">
                      <img src="@/assets/navbar/navbar_hoverMenu_2_1.png" style="width: 100%">
                    </div>
                    <!-- title, sub -->
                    <div class="d-flex flex-column" style="gap: 4px">
                      <!-- title -->
                      <div style="font-size: 18px; font-weight: 500; line-height: 25px; letter-spacing: -0.02em; color: #0D0E17">
                        Case Study
                      </div>
                      <!-- title -->
                      <div style="font-size: 15px; font-weight: 400; line-height: 21px; letter-spacing: -0.02em; color: #414458">
                        리컬럼의 사용 사례를 공유합니다.
                      </div>
                    </div>
                  </div>
                  <!-- Use Case -->
                  <div @click="windowOpen('https://blog.naver.com/PostList.naver?blogId=cogcominc&from=postList&categoryNo=8')" class="navbar-menu-list-item d-flex align-center" style="width: 100%; height: 96px; gap: 20px; cursor: pointer">
                    <!-- img -->
                    <div style="width: 120px; height: 100%; border-radius: 9.6px; border: 1.2px solid #E8EAF2; overflow: hidden">
                      <img src="@/assets/navbar/navbar_hoverMenu_2_2.png" style="width: 100%">
                    </div>
                    <!-- title, sub -->
                    <div class="d-flex flex-column" style="gap: 4px">
                      <!-- title -->
                      <div style="font-size: 18px; font-weight: 500; line-height: 25px; letter-spacing: -0.02em; color: #0D0E17">
                        Use Case
                      </div>
                      <!-- title -->
                      <div style="font-size: 15px; font-weight: 400; line-height: 21px; letter-spacing: -0.02em; color: #414458">
                        코그콤의 실제 고객 사례를 공유합니다.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </v-menu>
            <!-- 인사이트 -->
            <v-menu offset-y open-on-hover content-class="elevation-0" nudge-left="296">
              <template v-slot:activator="{ on }">
                <div v-on="on"
                  class="hover-bg-color d-flex align-center"
                  style="--hover-bg-color: #EFF0F6; height: 50px; padding: 0px 24px; border-radius: 999px; cursor: pointer"
                >
                  <div style="font-size: 17px; font-weight: 500; line-height: 24px; letter-spacing: -0.02em; color: #0D0E17">
                    인사이트
                  </div>
                </div>
              </template>
              <div style="width: 480px; padding-top: 15px">
                <div class="d-flex flex-column" style="width: 100%; background-color: #ffffff; border-radius: 0px 0px 16px 16px; padding: 16px 30px 28px; gap: 20px">
                  <!-- News -->
                  <div @click="windowOpen('https://blog.naver.com/PostList.naver?blogId=cogcominc&from=postList&categoryNo=1')" class="navbar-menu-list-item d-flex align-center" style="width: 100%; height: 96px; gap: 20px; cursor: pointer">
                    <!-- img -->
                    <div style="width: 120px; height: 100%; border-radius: 9.6px; border: 1.2px solid #E8EAF2; overflow: hidden">
                      <img src="@/assets/navbar/navbar_hoverMenu_3_1.png" style="width: 100%">
                    </div>
                    <!-- title, sub -->
                    <div class="d-flex flex-column" style="gap: 4px">
                      <!-- title -->
                      <div style="font-size: 18px; font-weight: 500; line-height: 25px; letter-spacing: -0.02em; color: #0D0E17">
                        News
                      </div>
                      <!-- title -->
                      <div style="font-size: 15px; font-weight: 400; line-height: 21px; letter-spacing: -0.02em; color: #414458">
                        코그콤의 최신 소식을 공유합니다.
                      </div>
                    </div>
                  </div>
                  <!-- Trends -->
                  <div @click="windowOpen('https://blog.naver.com/PostList.naver?blogId=cogcominc&from=postList&categoryNo=6')" class="navbar-menu-list-item d-flex align-center" style="width: 100%; height: 96px; gap: 20px; cursor: pointer">
                    <!-- img -->
                    <div style="width: 120px; height: 100%; border-radius: 9.6px; border: 1.2px solid #E8EAF2; overflow: hidden">
                      <img src="@/assets/navbar/navbar_hoverMenu_3_2.png" style="width: 100%">
                    </div>
                    <!-- title, sub -->
                    <div class="d-flex flex-column" style="gap: 4px">
                      <!-- title -->
                      <div style="font-size: 18px; font-weight: 500; line-height: 25px; letter-spacing: -0.02em; color: #0D0E17">
                        Trends
                      </div>
                      <!-- title -->
                      <div style="font-size: 15px; font-weight: 400; line-height: 21px; letter-spacing: -0.02em; color: #414458">
                        업계의 최근 동향을 공유합니다.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </v-menu>
          </div>
          <!-- 우측 버튼(absolute) - 연락처, 문의하기 버튼 -->
          <div class="d-flex align-center" style="position: absolute; right: 0; gap: 16px">
            <!-- 연락처 -->
            <div class="d-flex align-center" style="height: 40px; padding: 0px 10px; gap: 4px">
              <v-icon style="font-size: 18px; color: #0D0E17">
                mdi-phone
              </v-icon>
              <div style="font-size: 16px; font-weight: 400; line-height: 22px; color: #0D0E17">
                02-2088-2096
              </div>
            </div>
            <!-- 문의하기 버튼 -->
            <div @click="openGoogleForm()"
              class="hover-bg-color-important d-flex align-center justify-center"
              style="--hover-bg-color: #EB3A00; height: 50px; padding: 0px 12px 0px 18px; background-color: #FF6A39; border-radius: 8px; gap: 4px; cursor: pointer"
            >
              <div style="font-size: 17px; font-weight: 600; line-height: 24px; letter-spacing: -0.02em; color: #ffffff">
                문의하기
              </div>
              <v-icon style="font-size: 20px; color: #ffffff">
                mdi-arrow-right
              </v-icon>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- navbar (show-over-1281px-under-1536px) -->
    <div class="show-over-1281px-under-1536px" style="position: sticky; top: 0; z-index: 99; height: 80px; width: 100%; background-color: #ffffff; border-bottom: 1px solid #EFF0F6; box-shadow: 0px 2px 4px 0px #2424241A">
      <div class="d-flex align-center justify-center" style="height: 100%; width: 100%">
        <div class="d-flex align-center justify-center" style="width: 1181px; position: relative">
          <!-- logo(absolute) -->
          <img @click="goHome()" src="@/assets/cogcom_logo.png" style="position: absolute; left: 0; height: 29px; cursor: pointer">
          <!-- tabs - 솔루션, 활용 사례, 인사이트 -->
          <div class="d-flex align-center" style="gap: 10px; position: relative">
            <!-- 솔루션 -->
            <v-menu offset-y open-on-hover content-class="elevation-0" nudge-left="76">
              <template v-slot:activator="{ on }">
                <div v-on="on"
                  class="hover-bg-color d-flex align-center"
                  style="--hover-bg-color: #EFF0F6; height: 50px; padding: 0px 24px; border-radius: 999px; cursor: pointer"
                >
                  <div style="font-size: 17px; font-weight: 500; line-height: 24px; letter-spacing: -0.02em; color: #0D0E17">
                    솔루션
                  </div>
                </div>
              </template>
              <div style="width: 480px; padding-top: 15px">
                <div class="d-flex flex-column" style="width: 100%; background-color: #ffffff; border-radius: 0px 0px 16px 16px; padding: 16px 30px 28px; gap: 20px">
                  <!-- Re:Column -->
                  <div @click="openRecolumn()" class="navbar-menu-list-item d-flex align-center" style="width: 100%; height: 96px; gap: 20px; cursor: pointer">
                    <!-- img -->
                    <div style="width: 120px; height: 100%; border-radius: 9.6px; border: 1.2px solid #E8EAF2; overflow: hidden">
                      <img src="@/assets/navbar/navbar_hoverMenu_1_1.png" style="width: 100%">
                    </div>
                    <!-- title, sub -->
                    <div class="d-flex flex-column" style="gap: 4px">
                      <!-- title -->
                      <div style="font-size: 18px; font-weight: 500; line-height: 25px; letter-spacing: -0.02em; color: #0D0E17">
                        Re:Column
                      </div>
                      <!-- title -->
                      <div style="font-size: 15px; font-weight: 400; line-height: 21px; letter-spacing: -0.02em; color: #414458">
                        데이터 ∙ 문서 업무가 반복된다면, <br> 리컬럼 도입을 고려하실 때입니다.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </v-menu>
            <!-- 활용 사례 -->
            <v-menu offset-y open-on-hover content-class="elevation-0" nudge-left="177">
              <template v-slot:activator="{ on }">
                <div v-on="on"
                  class="hover-bg-color d-flex align-center"
                  style="--hover-bg-color: #EFF0F6; height: 50px; padding: 0px 24px; border-radius: 999px; cursor: pointer"
                >
                  <div style="font-size: 17px; font-weight: 500; line-height: 24px; letter-spacing: -0.02em; color: #0D0E17">
                    활용 사례
                  </div>
                </div>
              </template>
              <div style="width: 480px; padding-top: 15px">
                <div class="d-flex flex-column" style="width: 100%; background-color: #ffffff; border-radius: 0px 0px 16px 16px; padding: 16px 30px 28px; gap: 20px">
                  <!-- Case Study -->
                  <div @click="windowOpen('https://blog.naver.com/PostList.naver?blogId=cogcominc&from=postList&categoryNo=7')" class="navbar-menu-list-item d-flex align-center" style="width: 100%; height: 96px; gap: 20px; cursor: pointer">
                    <!-- img -->
                    <div style="width: 120px; height: 100%; border-radius: 9.6px; border: 1.2px solid #E8EAF2; overflow: hidden">
                      <img src="@/assets/navbar/navbar_hoverMenu_2_1.png" style="width: 100%">
                    </div>
                    <!-- title, sub -->
                    <div class="d-flex flex-column" style="gap: 4px">
                      <!-- title -->
                      <div style="font-size: 18px; font-weight: 500; line-height: 25px; letter-spacing: -0.02em; color: #0D0E17">
                        Case Study
                      </div>
                      <!-- title -->
                      <div style="font-size: 15px; font-weight: 400; line-height: 21px; letter-spacing: -0.02em; color: #414458">
                        리컬럼의 사용 사례를 공유합니다.
                      </div>
                    </div>
                  </div>
                  <!-- Use Case -->
                  <div @click="windowOpen('https://blog.naver.com/PostList.naver?blogId=cogcominc&from=postList&categoryNo=8')" class="navbar-menu-list-item d-flex align-center" style="width: 100%; height: 96px; gap: 20px; cursor: pointer">
                    <!-- img -->
                    <div style="width: 120px; height: 100%; border-radius: 9.6px; border: 1.2px solid #E8EAF2; overflow: hidden">
                      <img src="@/assets/navbar/navbar_hoverMenu_2_2.png" style="width: 100%">
                    </div>
                    <!-- title, sub -->
                    <div class="d-flex flex-column" style="gap: 4px">
                      <!-- title -->
                      <div style="font-size: 18px; font-weight: 500; line-height: 25px; letter-spacing: -0.02em; color: #0D0E17">
                        Use Case
                      </div>
                      <!-- title -->
                      <div style="font-size: 15px; font-weight: 400; line-height: 21px; letter-spacing: -0.02em; color: #414458">
                        코그콤의 실제 고객 사례를 공유합니다.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </v-menu>
            <!-- 인사이트 -->
            <v-menu offset-y open-on-hover content-class="elevation-0" nudge-left="296">
              <template v-slot:activator="{ on }">
                <div v-on="on"
                  class="hover-bg-color d-flex align-center"
                  style="--hover-bg-color: #EFF0F6; height: 50px; padding: 0px 24px; border-radius: 999px; cursor: pointer"
                >
                  <div style="font-size: 17px; font-weight: 500; line-height: 24px; letter-spacing: -0.02em; color: #0D0E17">
                    인사이트
                  </div>
                </div>
              </template>
              <div style="width: 480px; padding-top: 15px">
                <div class="d-flex flex-column" style="width: 100%; background-color: #ffffff; border-radius: 0px 0px 16px 16px; padding: 16px 30px 28px; gap: 20px">
                  <!-- News -->
                  <div @click="windowOpen('https://blog.naver.com/PostList.naver?blogId=cogcominc&from=postList&categoryNo=1')" class="navbar-menu-list-item d-flex align-center" style="width: 100%; height: 96px; gap: 20px; cursor: pointer">
                    <!-- img -->
                    <div style="width: 120px; height: 100%; border-radius: 9.6px; border: 1.2px solid #E8EAF2; overflow: hidden">
                      <img src="@/assets/navbar/navbar_hoverMenu_3_1.png" style="width: 100%">
                    </div>
                    <!-- title, sub -->
                    <div class="d-flex flex-column" style="gap: 4px">
                      <!-- title -->
                      <div style="font-size: 18px; font-weight: 500; line-height: 25px; letter-spacing: -0.02em; color: #0D0E17">
                        News
                      </div>
                      <!-- title -->
                      <div style="font-size: 15px; font-weight: 400; line-height: 21px; letter-spacing: -0.02em; color: #414458">
                        코그콤의 최신 소식을 공유합니다.
                      </div>
                    </div>
                  </div>
                  <!-- Trends -->
                  <div @click="windowOpen('https://blog.naver.com/PostList.naver?blogId=cogcominc&from=postList&categoryNo=6')" class="navbar-menu-list-item d-flex align-center" style="width: 100%; height: 96px; gap: 20px; cursor: pointer">
                    <!-- img -->
                    <div style="width: 120px; height: 100%; border-radius: 9.6px; border: 1.2px solid #E8EAF2; overflow: hidden">
                      <img src="@/assets/navbar/navbar_hoverMenu_3_2.png" style="width: 100%">
                    </div>
                    <!-- title, sub -->
                    <div class="d-flex flex-column" style="gap: 4px">
                      <!-- title -->
                      <div style="font-size: 18px; font-weight: 500; line-height: 25px; letter-spacing: -0.02em; color: #0D0E17">
                        Trends
                      </div>
                      <!-- title -->
                      <div style="font-size: 15px; font-weight: 400; line-height: 21px; letter-spacing: -0.02em; color: #414458">
                        업계의 최근 동향을 공유합니다.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </v-menu>
          </div>
          <!-- 우측 버튼(absolute) - 연락처, 문의하기 버튼 -->
          <div class="d-flex align-center" style="position: absolute; right: 0; gap: 16px">
            <!-- 연락처 -->
            <div class="d-flex align-center" style="height: 40px; padding: 0px 10px; gap: 4px">
              <v-icon style="font-size: 18px; color: #0D0E17">
                mdi-phone
              </v-icon>
              <div style="font-size: 16px; font-weight: 400; line-height: 22px; color: #0D0E17">
                02-2088-2096
              </div>
            </div>
            <!-- 문의하기 버튼 -->
            <div @click="openGoogleForm()"
              class="hover-bg-color-important d-flex align-center justify-center"
              style="--hover-bg-color: #EB3A00; height: 50px; padding: 0px 12px 0px 18px; background-color: #FF6A39; border-radius: 8px; gap: 4px; cursor: pointer"
            >
              <div style="font-size: 17px; font-weight: 600; line-height: 24px; letter-spacing: -0.02em; color: #ffffff">
                문의하기
              </div>
              <v-icon style="font-size: 20px; color: #ffffff">
                mdi-arrow-right
              </v-icon>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- navbar (show-over-1025px-under-1280px) -->
    <div class="show-over-1025px-under-1280px" style="position: sticky; top: 0; z-index: 99; height: 80px; width: 100%; background-color: #ffffff; border-bottom: 1px solid #EFF0F6; box-shadow: 0px 2px 4px 0px #2424241A">
      <div class="d-flex align-center justify-center" style="height: 100%; width: 100%">
        <div class="d-flex align-center justify-center" style="width: 925px; position: relative">
          <!-- logo(absolute) -->
          <img @click="goHome()" src="@/assets/cogcom_logo.png" style="position: absolute; left: 0; height: 29px; cursor: pointer">
          <!-- tabs - 솔루션, 활용 사례, 인사이트 -->
          <div class="d-flex align-center" style="gap: 10px; position: relative">
            <!-- 솔루션 -->
            <v-menu offset-y open-on-hover content-class="elevation-0" nudge-left="76">
              <template v-slot:activator="{ on }">
                <div v-on="on"
                  class="hover-bg-color d-flex align-center"
                  style="--hover-bg-color: #EFF0F6; height: 50px; padding: 0px 24px; border-radius: 999px; cursor: pointer"
                >
                  <div style="font-size: 17px; font-weight: 500; line-height: 24px; letter-spacing: -0.02em; color: #0D0E17">
                    솔루션
                  </div>
                </div>
              </template>
              <div style="width: 480px; padding-top: 15px">
                <div class="d-flex flex-column" style="width: 100%; background-color: #ffffff; border-radius: 0px 0px 16px 16px; padding: 16px 30px 28px; gap: 20px">
                  <!-- Re:Column -->
                  <div @click="openRecolumn()" class="navbar-menu-list-item d-flex align-center" style="width: 100%; height: 96px; gap: 20px; cursor: pointer">
                    <!-- img -->
                    <div style="width: 120px; height: 100%; border-radius: 9.6px; border: 1.2px solid #E8EAF2; overflow: hidden">
                      <img src="@/assets/navbar/navbar_hoverMenu_1_1.png" style="width: 100%">
                    </div>
                    <!-- title, sub -->
                    <div class="d-flex flex-column" style="gap: 4px">
                      <!-- title -->
                      <div style="font-size: 18px; font-weight: 500; line-height: 25px; letter-spacing: -0.02em; color: #0D0E17">
                        Re:Column
                      </div>
                      <!-- title -->
                      <div style="font-size: 15px; font-weight: 400; line-height: 21px; letter-spacing: -0.02em; color: #414458">
                        데이터 ∙ 문서 업무가 반복된다면, <br> 리컬럼 도입을 고려하실 때입니다.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </v-menu>
            <!-- 활용 사례 -->
            <v-menu offset-y open-on-hover content-class="elevation-0" nudge-left="177">
              <template v-slot:activator="{ on }">
                <div v-on="on"
                  class="hover-bg-color d-flex align-center"
                  style="--hover-bg-color: #EFF0F6; height: 50px; padding: 0px 24px; border-radius: 999px; cursor: pointer"
                >
                  <div style="font-size: 17px; font-weight: 500; line-height: 24px; letter-spacing: -0.02em; color: #0D0E17">
                    활용 사례
                  </div>
                </div>
              </template>
              <div style="width: 480px; padding-top: 15px">
                <div class="d-flex flex-column" style="width: 100%; background-color: #ffffff; border-radius: 0px 0px 16px 16px; padding: 16px 30px 28px; gap: 20px">
                  <!-- Case Study -->
                  <div @click="windowOpen('https://blog.naver.com/PostList.naver?blogId=cogcominc&from=postList&categoryNo=7')" class="navbar-menu-list-item d-flex align-center" style="width: 100%; height: 96px; gap: 20px; cursor: pointer">
                    <!-- img -->
                    <div style="width: 120px; height: 100%; border-radius: 9.6px; border: 1.2px solid #E8EAF2; overflow: hidden">
                      <img src="@/assets/navbar/navbar_hoverMenu_2_1.png" style="width: 100%">
                    </div>
                    <!-- title, sub -->
                    <div class="d-flex flex-column" style="gap: 4px">
                      <!-- title -->
                      <div style="font-size: 18px; font-weight: 500; line-height: 25px; letter-spacing: -0.02em; color: #0D0E17">
                        Case Study
                      </div>
                      <!-- title -->
                      <div style="font-size: 15px; font-weight: 400; line-height: 21px; letter-spacing: -0.02em; color: #414458">
                        리컬럼의 사용 사례를 공유합니다.
                      </div>
                    </div>
                  </div>
                  <!-- Use Case -->
                  <div @click="windowOpen('https://blog.naver.com/PostList.naver?blogId=cogcominc&from=postList&categoryNo=8')" class="navbar-menu-list-item d-flex align-center" style="width: 100%; height: 96px; gap: 20px; cursor: pointer">
                    <!-- img -->
                    <div style="width: 120px; height: 100%; border-radius: 9.6px; border: 1.2px solid #E8EAF2; overflow: hidden">
                      <img src="@/assets/navbar/navbar_hoverMenu_2_2.png" style="width: 100%">
                    </div>
                    <!-- title, sub -->
                    <div class="d-flex flex-column" style="gap: 4px">
                      <!-- title -->
                      <div style="font-size: 18px; font-weight: 500; line-height: 25px; letter-spacing: -0.02em; color: #0D0E17">
                        Use Case
                      </div>
                      <!-- title -->
                      <div style="font-size: 15px; font-weight: 400; line-height: 21px; letter-spacing: -0.02em; color: #414458">
                        코그콤의 실제 고객 사례를 공유합니다.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </v-menu>
            <!-- 인사이트 -->
            <v-menu offset-y open-on-hover content-class="elevation-0" nudge-left="296">
              <template v-slot:activator="{ on }">
                <div v-on="on"
                  class="hover-bg-color d-flex align-center"
                  style="--hover-bg-color: #EFF0F6; height: 50px; padding: 0px 24px; border-radius: 999px; cursor: pointer"
                >
                  <div style="font-size: 17px; font-weight: 500; line-height: 24px; letter-spacing: -0.02em; color: #0D0E17">
                    인사이트
                  </div>
                </div>
              </template>
              <div style="width: 480px; padding-top: 15px">
                <div class="d-flex flex-column" style="width: 100%; background-color: #ffffff; border-radius: 0px 0px 16px 16px; padding: 16px 30px 28px; gap: 20px">
                  <!-- News -->
                  <div @click="windowOpen('https://blog.naver.com/PostList.naver?blogId=cogcominc&from=postList&categoryNo=1')" class="navbar-menu-list-item d-flex align-center" style="width: 100%; height: 96px; gap: 20px; cursor: pointer">
                    <!-- img -->
                    <div style="width: 120px; height: 100%; border-radius: 9.6px; border: 1.2px solid #E8EAF2; overflow: hidden">
                      <img src="@/assets/navbar/navbar_hoverMenu_3_1.png" style="width: 100%">
                    </div>
                    <!-- title, sub -->
                    <div class="d-flex flex-column" style="gap: 4px">
                      <!-- title -->
                      <div style="font-size: 18px; font-weight: 500; line-height: 25px; letter-spacing: -0.02em; color: #0D0E17">
                        News
                      </div>
                      <!-- title -->
                      <div style="font-size: 15px; font-weight: 400; line-height: 21px; letter-spacing: -0.02em; color: #414458">
                        코그콤의 최신 소식을 공유합니다.
                      </div>
                    </div>
                  </div>
                  <!-- Trends -->
                  <div @click="windowOpen('https://blog.naver.com/PostList.naver?blogId=cogcominc&from=postList&categoryNo=6')" class="navbar-menu-list-item d-flex align-center" style="width: 100%; height: 96px; gap: 20px; cursor: pointer">
                    <!-- img -->
                    <div style="width: 120px; height: 100%; border-radius: 9.6px; border: 1.2px solid #E8EAF2; overflow: hidden">
                      <img src="@/assets/navbar/navbar_hoverMenu_3_2.png" style="width: 100%">
                    </div>
                    <!-- title, sub -->
                    <div class="d-flex flex-column" style="gap: 4px">
                      <!-- title -->
                      <div style="font-size: 18px; font-weight: 500; line-height: 25px; letter-spacing: -0.02em; color: #0D0E17">
                        Trends
                      </div>
                      <!-- title -->
                      <div style="font-size: 15px; font-weight: 400; line-height: 21px; letter-spacing: -0.02em; color: #414458">
                        업계의 최근 동향을 공유합니다.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </v-menu>
          </div>
          <!-- 우측 버튼(absolute) - 문의하기 버튼 -->
          <div class="d-flex align-center" style="position: absolute; right: 0; gap: 16px">
            <!-- 문의하기 버튼 -->
            <div @click="openGoogleForm()"
              class="hover-bg-color-important d-flex align-center justify-center"
              style="--hover-bg-color: #EB3A00; height: 50px; padding: 0px 12px 0px 18px; background-color: #FF6A39; border-radius: 8px; gap: 4px; cursor: pointer"
            >
              <div style="font-size: 17px; font-weight: 600; line-height: 24px; letter-spacing: -0.02em; color: #ffffff">
                문의하기
              </div>
              <v-icon style="font-size: 20px; color: #ffffff">
                mdi-arrow-right
              </v-icon>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- navbar (show-over-769px-under-1024px) -->
    <div class="show-over-769px-under-1024px" style="position: sticky; top: 0; z-index: 99; height: 80px; width: 100%; background-color: #ffffff; border-bottom: 1px solid #EFF0F6; box-shadow: 0px 2px 4px 0px #2424241A">
      <div class="d-flex align-center justify-center" style="height: 100%; width: 100%">
        <div class="d-flex align-center justify-center" style="width: 709px; position: relative">
          <!-- logo(absolute) -->
          <img @click="goHome()" src="@/assets/cogcom_logo.png" style="position: absolute; left: 30px; height: 29px; cursor: pointer">
          <!-- tabs - 솔루션, 활용 사례, 인사이트 -->
          <div class="d-flex align-center" style="gap: 10px; position: relative">
            <!-- 솔루션 -->
            <v-menu offset-y open-on-hover content-class="elevation-0" nudge-left="76">
              <template v-slot:activator="{ on }">
                <div v-on="on"
                  class="hover-bg-color d-flex align-center"
                  style="--hover-bg-color: #EFF0F6; height: 50px; padding: 0px 24px; border-radius: 999px; cursor: pointer"
                >
                  <div style="font-size: 17px; font-weight: 500; line-height: 24px; letter-spacing: -0.02em; color: #0D0E17">
                    솔루션
                  </div>
                </div>
              </template>
              <div style="width: 480px; padding-top: 15px">
                <div class="d-flex flex-column" style="width: 100%; background-color: #ffffff; border-radius: 0px 0px 16px 16px; padding: 16px 30px 28px; gap: 20px">
                  <!-- Re:Column -->
                  <div @click="openRecolumn()" class="navbar-menu-list-item d-flex align-center" style="width: 100%; height: 96px; gap: 20px; cursor: pointer">
                    <!-- img -->
                    <div style="width: 120px; height: 100%; border-radius: 9.6px; border: 1.2px solid #E8EAF2; overflow: hidden">
                      <img src="@/assets/navbar/navbar_hoverMenu_1_1.png" style="width: 100%">
                    </div>
                    <!-- title, sub -->
                    <div class="d-flex flex-column" style="gap: 4px">
                      <!-- title -->
                      <div style="font-size: 18px; font-weight: 500; line-height: 25px; letter-spacing: -0.02em; color: #0D0E17">
                        Re:Column
                      </div>
                      <!-- title -->
                      <div style="font-size: 15px; font-weight: 400; line-height: 21px; letter-spacing: -0.02em; color: #414458">
                        데이터 ∙ 문서 업무가 반복된다면, <br> 리컬럼 도입을 고려하실 때입니다.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </v-menu>
            <!-- 활용 사례 -->
            <v-menu offset-y open-on-hover content-class="elevation-0" nudge-left="177">
              <template v-slot:activator="{ on }">
                <div v-on="on"
                  class="hover-bg-color d-flex align-center"
                  style="--hover-bg-color: #EFF0F6; height: 50px; padding: 0px 24px; border-radius: 999px; cursor: pointer"
                >
                  <div style="font-size: 17px; font-weight: 500; line-height: 24px; letter-spacing: -0.02em; color: #0D0E17">
                    활용 사례
                  </div>
                </div>
              </template>
              <div style="width: 480px; padding-top: 15px">
                <div class="d-flex flex-column" style="width: 100%; background-color: #ffffff; border-radius: 0px 0px 16px 16px; padding: 16px 30px 28px; gap: 20px">
                  <!-- Case Study -->
                  <div @click="windowOpen('https://blog.naver.com/PostList.naver?blogId=cogcominc&from=postList&categoryNo=7')" class="navbar-menu-list-item d-flex align-center" style="width: 100%; height: 96px; gap: 20px; cursor: pointer">
                    <!-- img -->
                    <div style="width: 120px; height: 100%; border-radius: 9.6px; border: 1.2px solid #E8EAF2; overflow: hidden">
                      <img src="@/assets/navbar/navbar_hoverMenu_2_1.png" style="width: 100%">
                    </div>
                    <!-- title, sub -->
                    <div class="d-flex flex-column" style="gap: 4px">
                      <!-- title -->
                      <div style="font-size: 18px; font-weight: 500; line-height: 25px; letter-spacing: -0.02em; color: #0D0E17">
                        Case Study
                      </div>
                      <!-- title -->
                      <div style="font-size: 15px; font-weight: 400; line-height: 21px; letter-spacing: -0.02em; color: #414458">
                        리컬럼의 사용 사례를 공유합니다.
                      </div>
                    </div>
                  </div>
                  <!-- Use Case -->
                  <div @click="windowOpen('https://blog.naver.com/PostList.naver?blogId=cogcominc&from=postList&categoryNo=8')" class="navbar-menu-list-item d-flex align-center" style="width: 100%; height: 96px; gap: 20px; cursor: pointer">
                    <!-- img -->
                    <div style="width: 120px; height: 100%; border-radius: 9.6px; border: 1.2px solid #E8EAF2; overflow: hidden">
                      <img src="@/assets/navbar/navbar_hoverMenu_2_2.png" style="width: 100%">
                    </div>
                    <!-- title, sub -->
                    <div class="d-flex flex-column" style="gap: 4px">
                      <!-- title -->
                      <div style="font-size: 18px; font-weight: 500; line-height: 25px; letter-spacing: -0.02em; color: #0D0E17">
                        Use Case
                      </div>
                      <!-- title -->
                      <div style="font-size: 15px; font-weight: 400; line-height: 21px; letter-spacing: -0.02em; color: #414458">
                        코그콤의 실제 고객 사례를 공유합니다.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </v-menu>
            <!-- 인사이트 -->
            <v-menu offset-y open-on-hover content-class="elevation-0" nudge-left="296">
              <template v-slot:activator="{ on }">
                <div v-on="on"
                  class="hover-bg-color d-flex align-center"
                  style="--hover-bg-color: #EFF0F6; height: 50px; padding: 0px 24px; border-radius: 999px; cursor: pointer"
                >
                  <div style="font-size: 17px; font-weight: 500; line-height: 24px; letter-spacing: -0.02em; color: #0D0E17">
                    인사이트
                  </div>
                </div>
              </template>
              <div style="width: 480px; padding-top: 15px">
                <div class="d-flex flex-column" style="width: 100%; background-color: #ffffff; border-radius: 0px 0px 16px 16px; padding: 16px 30px 28px; gap: 20px">
                  <!-- News -->
                  <div @click="windowOpen('https://blog.naver.com/PostList.naver?blogId=cogcominc&from=postList&categoryNo=1')" class="navbar-menu-list-item d-flex align-center" style="width: 100%; height: 96px; gap: 20px; cursor: pointer">
                    <!-- img -->
                    <div style="width: 120px; height: 100%; border-radius: 9.6px; border: 1.2px solid #E8EAF2; overflow: hidden">
                      <img src="@/assets/navbar/navbar_hoverMenu_3_1.png" style="width: 100%">
                    </div>
                    <!-- title, sub -->
                    <div class="d-flex flex-column" style="gap: 4px">
                      <!-- title -->
                      <div style="font-size: 18px; font-weight: 500; line-height: 25px; letter-spacing: -0.02em; color: #0D0E17">
                        News
                      </div>
                      <!-- title -->
                      <div style="font-size: 15px; font-weight: 400; line-height: 21px; letter-spacing: -0.02em; color: #414458">
                        코그콤의 최신 소식을 공유합니다.
                      </div>
                    </div>
                  </div>
                  <!-- Trends -->
                  <div @click="windowOpen('https://blog.naver.com/PostList.naver?blogId=cogcominc&from=postList&categoryNo=6')" class="navbar-menu-list-item d-flex align-center" style="width: 100%; height: 96px; gap: 20px; cursor: pointer">
                    <!-- img -->
                    <div style="width: 120px; height: 100%; border-radius: 9.6px; border: 1.2px solid #E8EAF2; overflow: hidden">
                      <img src="@/assets/navbar/navbar_hoverMenu_3_2.png" style="width: 100%">
                    </div>
                    <!-- title, sub -->
                    <div class="d-flex flex-column" style="gap: 4px">
                      <!-- title -->
                      <div style="font-size: 18px; font-weight: 500; line-height: 25px; letter-spacing: -0.02em; color: #0D0E17">
                        Trends
                      </div>
                      <!-- title -->
                      <div style="font-size: 15px; font-weight: 400; line-height: 21px; letter-spacing: -0.02em; color: #414458">
                        업계의 최근 동향을 공유합니다.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </v-menu>
          </div>
          <!-- 우측 버튼(absolute) - 문의하기 버튼 -->
          <div class="d-flex align-center" style="position: absolute; right: 30px; gap: 16px">
            <!-- 문의하기 버튼 -->
            <div @click="openGoogleForm()"
              class="hover-bg-color-important d-flex align-center justify-center"
              style="--hover-bg-color: #EB3A00; height: 50px; padding: 0px 12px 0px 18px; background-color: #FF6A39; border-radius: 8px; gap: 4px; cursor: pointer"
            >
              <div style="font-size: 17px; font-weight: 600; line-height: 24px; letter-spacing: -0.02em; color: #ffffff">
                문의하기
              </div>
              <v-icon style="font-size: 20px; color: #ffffff">
                mdi-arrow-right
              </v-icon>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- navbar (show-under-768px) -->
    <div class="show-under-768px" style="position: sticky; top: 0; z-index: 99; height: 60px; width: 100%; background-color: #ffffff; border-bottom: 1px solid #EFF0F6; box-shadow: 0px 2px 4px 0px #2424241A">
      <div class="d-flex align-center justify-center" style="height: 100%; width: 100%; position: relative">
        <!-- logo(absolute) -->
        <img @click="goHome()" src="@/assets/cogcom_logo.png" style="position: absolute; left: 16px; height: 29px; cursor: pointer">
        <!-- 우측 버튼(absolute) - 햄버거 메뉴 버튼 -->
        <div class="d-flex align-center" style="position: absolute; right: 16px; gap: 16px">
          <!-- 햄버거 메뉴 버튼 -->
          <div @click="isShowHamburgerMenu = !isShowHamburgerMenu"
            class="d-flex align-center justify-center"
            style="width: 44px; height: 44px"
          >
            <v-icon style="font-size: 28px; color: #0D0E17">
              mdi-menu
            </v-icon>
          </div>
          <!-- 햄버거 메뉴 -->
          <div v-if="isShowHamburgerMenu" class="d-flex flex-column" style="position: fixed; top: 60px; left: 0px; width: 100vw; height: calc(100vh - 60px); background-color: #ffffff; padding: 28px 24px; gap: 16px">
            <!-- Re:Column -->
            <div @click="openRecolumn()" class="navbar-menu-list-item d-flex align-center" style="width: 100%; height: 96px; gap: 20px; cursor: pointer">
              <!-- img -->
              <div style="min-width: 120px; height: 100%; border-radius: 9.6px; border: 1.2px solid #E8EAF2; overflow: hidden">
                <img src="@/assets/navbar/navbar_hoverMenu_1_1.png" style="width: 100%">
              </div>
              <!-- title, sub -->
              <div class="d-flex flex-column" style="gap: 4px">
                <!-- title -->
                <div style="font-size: 18px; font-weight: 500; line-height: 25px; letter-spacing: -0.02em; color: #0D0E17">
                  Re:Column
                </div>
                <!-- title -->
                <div style="font-size: 15px; font-weight: 400; line-height: 21px; letter-spacing: -0.02em; color: #414458">
                  데이터 ∙ 문서 업무가 반복된다면, 리컬럼 도입을 고려하실 때입니다.
                </div>
              </div>
            </div>
            <!-- Case Study -->
            <div @click="windowOpen('https://blog.naver.com/PostList.naver?blogId=cogcominc&from=postList&categoryNo=7')" class="navbar-menu-list-item d-flex align-center" style="width: 100%; height: 96px; gap: 20px; cursor: pointer">
              <!-- img -->
              <div style="min-width: 120px; height: 100%; border-radius: 9.6px; border: 1.2px solid #E8EAF2; overflow: hidden">
                <img src="@/assets/navbar/navbar_hoverMenu_2_1.png" style="width: 100%">
              </div>
              <!-- title, sub -->
              <div class="d-flex flex-column" style="gap: 4px">
                <!-- title -->
                <div style="font-size: 18px; font-weight: 500; line-height: 25px; letter-spacing: -0.02em; color: #0D0E17">
                  Case Study
                </div>
                <!-- title -->
                <div style="font-size: 15px; font-weight: 400; line-height: 21px; letter-spacing: -0.02em; color: #414458">
                  리컬럼의 사용 사례를 공유합니다.
                </div>
              </div>
            </div>
            <!-- Use Case -->
            <div @click="windowOpen('https://blog.naver.com/PostList.naver?blogId=cogcominc&from=postList&categoryNo=8')" class="navbar-menu-list-item d-flex align-center" style="width: 100%; height: 96px; gap: 20px; cursor: pointer">
              <!-- img -->
              <div style="min-width: 120px; height: 100%; border-radius: 9.6px; border: 1.2px solid #E8EAF2; overflow: hidden">
                <img src="@/assets/navbar/navbar_hoverMenu_2_2.png" style="width: 100%">
              </div>
              <!-- title, sub -->
              <div class="d-flex flex-column" style="gap: 4px">
                <!-- title -->
                <div style="font-size: 18px; font-weight: 500; line-height: 25px; letter-spacing: -0.02em; color: #0D0E17">
                  Use Case
                </div>
                <!-- title -->
                <div style="font-size: 15px; font-weight: 400; line-height: 21px; letter-spacing: -0.02em; color: #414458">
                  코그콤의 실제 고객 사례를 공유합니다.
                </div>
              </div>
            </div>
            <!-- News -->
            <div @click="windowOpen('https://blog.naver.com/PostList.naver?blogId=cogcominc&from=postList&categoryNo=1')" class="navbar-menu-list-item d-flex align-center" style="width: 100%; height: 96px; gap: 20px; cursor: pointer">
              <!-- img -->
              <div style="min-width: 120px; height: 100%; border-radius: 9.6px; border: 1.2px solid #E8EAF2; overflow: hidden">
                <img src="@/assets/navbar/navbar_hoverMenu_3_1.png" style="width: 100%">
              </div>
              <!-- title, sub -->
              <div class="d-flex flex-column" style="gap: 4px">
                <!-- title -->
                <div style="font-size: 18px; font-weight: 500; line-height: 25px; letter-spacing: -0.02em; color: #0D0E17">
                  News
                </div>
                <!-- title -->
                <div style="font-size: 15px; font-weight: 400; line-height: 21px; letter-spacing: -0.02em; color: #414458">
                  코그콤의 최신 소식을 공유합니다.
                </div>
              </div>
            </div>
            <!-- Trends -->
            <div @click="windowOpen('https://blog.naver.com/PostList.naver?blogId=cogcominc&from=postList&categoryNo=6')" class="navbar-menu-list-item d-flex align-center" style="width: 100%; height: 96px; gap: 20px; cursor: pointer">
              <!-- img -->
              <div style="min-width: 120px; height: 100%; border-radius: 9.6px; border: 1.2px solid #E8EAF2; overflow: hidden">
                <img src="@/assets/navbar/navbar_hoverMenu_3_2.png" style="width: 100%">
              </div>
              <!-- title, sub -->
              <div class="d-flex flex-column" style="gap: 4px">
                <!-- title -->
                <div style="font-size: 18px; font-weight: 500; line-height: 25px; letter-spacing: -0.02em; color: #0D0E17">
                  Trends
                </div>
                <!-- title -->
                <div style="font-size: 15px; font-weight: 400; line-height: 21px; letter-spacing: -0.02em; color: #414458">
                  업계의 최근 동향을 공유합니다.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <v-main>
      <router-view/>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      hoveredNavbarMenuIdx: null,
      isShowHamburgerMenu: false,
    }
  },
  methods: {
    // navbar 메뉴 관련
    windowOpen(link) {
      console.log('windowOpen', link)
      window.open(link)
    },
    openRecolumn() {
      console.log('openRecolumn')
      window.open('https://www.recolumn.com/')
    },
    openGoogleForm() {
      console.log('openGoogleForm')
      window.open('https://docs.google.com/forms/d/e/1FAIpQLSfzSDiA4w-MdVhY_huzxVm8E_Y4yJVSWqmHvSxcoOPZtQSTRg/viewform')
    },
    goHome() {
      this.$router.push('/').catch(() => {})
      scrollTo(0, 0)
      this.navDrawer = false
    },
    goSolution() {
      this.$router.push('/solution').catch(() => {})
      scrollTo(0, 0)
      this.navDrawer = false
    },
    
    goInventier() {
      window.open('https://inventier.cogcom.kr/')
      this.navDrawer = false
    },
    goAiVoucher() {
      this.$router.push('/ai-voucher').catch(() => {})
      scrollTo(0, 0)
      this.navDrawer = false
    },
    goContact() {
      this.$router.push('/contact').catch(() => {})
      scrollTo(0, 0)
      this.navDrawer = false
    },
    goTechnology() {
      this.$router.push('/technology').catch(() => {})
      scrollTo(0, 0)
      this.navDrawer = false
    },
    goService() {
      this.$router.push('/service').catch(() => {})
      scrollTo(0, 0)
      this.navDrawer = false
    },
    goCareer() {
      window.open('https://www.rocketpunch.com/companies/cogcom')
      this.navDrawer = false
    },
    closeNavDrawer() {
      this.navDrawer = false
    },
    goTop() {
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      })
    },
    goBottom() {
      window.scroll({
        top: document.body.scrollHeight,
        left: 0,
        behavior: 'smooth'
      })
    },
  }
}
</script>

<style>
/* -- 단일 너비 기준 -- */
/* 1537px 이상 */
@media (min-width: 1537px) {
  .show-over-1537px { display: block; }
}
/* 1536px 이하 */
@media (max-width: 1536px) {
  .show-over-1537px { display: none; }
}
/* 1281px 이상 */
@media (min-width: 1281px) {
  .show-over-1281px { display: block; }
}
/* 1280px 이하 */
@media (max-width: 1280px) {
  .show-over-1281px { display: none; }
}
/* 1025px 이상 */
@media (min-width: 1025px) {
  .show-over-1025px { display: block; }
}
/* 1024px 이하 */
@media (max-width: 1024px) {
  .show-over-1025px { display: none; }
}
/* 769px 이상 */
@media (min-width: 769px) {
  .show-under-768px { display: none; }
}
/* 768px 이하 */
@media (max-width: 768px) {
  .show-under-768px { display: block; }
}
/* 320px 이상 */
@media (min-width: 320px) {
  .show-over-320px { display: block; }
}
/* 319px 이하 */
@media (max-width: 319px) {
  .show-over-320px { display: none; }
}

/* -- 범위 기준 -- */
/* 기본적으로 모든 요소는 숨김 처리 */
.show-over-1281px-under-1536px { display: none; }
.show-over-1025px-under-1280px { display: none; }
.show-over-769px-under-1024px { display: none; }
.show-over-320px-under-768px { display: none; }

/* 1281px 이상 1536px 이하 */
@media (min-width: 1281px) and (max-width: 1536px) {
  .show-over-1281px-under-1536px { display: block !important; }

  /* 포함되는 범위 (아래) */
  .show-over-1025px-under-1536px { display: block !important; }
  .show-over-769px-under-1536px { display: block !important; }
  .show-over-320px-under-1536px { display: block !important; }
}
/* 1025px 이상 1280px 이하 */
@media (min-width: 1025px) and (max-width: 1280px) {
  .show-over-1025px-under-1280px { display: block !important; }

  /* 포함되는 범위 (위) */
  .show-over-1025px-under-1536px { display: block !important; }
  /* 포함되는 범위 (아래) */
  .show-over-769px-under-1280px { display: block !important; }
  .show-over-320px-under-1280px { display: block !important; }
}
/* 769px 이상 1024px 이하 */
@media (min-width: 769px) and (max-width: 1024px) {
  .show-over-769px-under-1024px { display: block !important; }

  /* 포함되는 범위 (위) */
  .show-over-769px-under-1536px { display: block !important; }
  .show-over-769px-under-1280px { display: block !important; }
  /* 포함되는 범위 (아래) */
  .show-over-320px-under-1024px { display: block !important; }
}
/* 320px 이상 768px 이하 */
@media (min-width: 320px) and (max-width: 768px) {
  .show-over-320px-under-768px { display: block !important; }

  /* 포함되는 범위 (위) */
  .show-over-320px-under-1536px { display: block !important; }
  .show-over-320px-under-1280px { display: block !important; }
  .show-over-320px-under-1024px { display: block !important; }
}

/* 스크롤 숨김 처리 */
.hide-scroll {
  -ms-overflow-style: none; /* IE, Edge */
  scrollbar-width: none; /* Firefox */
}
.hide-scroll::-webkit-scrollbar {
  display: none; /* Chrome, Safari, Opera */
}

.hover-child-color-important:hover div {
  color: var(--hover-child-text-color) !important;
}
.hover-child-color-important:hover .v-icon {
  color: var(--hover-child-icon-color) !important;
  transition: none;
}
.hover-bg-color:hover {
  background-color: var(--hover-bg-color);
}
.hover-bg-color-important:hover {
  background-color: var(--hover-bg-color) !important;
}
.hover-border-color:hover {
  border-color: var(--hover-border-color);
}
.hover-border-color-important:hover {
  border-color: var(--hover-border-color) !important;
}
.hover-border-width:hover {
  border-width: var(--hover-border-width);
}
.hover-border-width-important:hover {
  border-width: var(--hover-border-width) !important;
}
.hover-padding-bottom:hover {
  padding-bottom: var(--hover-padding-bottom);
}
.hover-padding-bottom-important:hover {
  padding-bottom: var(--hover-padding-bottom) !important;
}

.navbar-menu-list-item:hover img {
  transform: scale(1.1);
  transition: transform 0.2s ease;
}
</style>